module.exports = __webpack_public_path__ + "img/newBanner1.21ed16e8.png";